import ReactDOM from 'react-dom';

export default function PortalMenu({
  open,
  position = {},
  children,
  zIndex = 2000,
}) {
  if (!open) return null;
  return ReactDOM.createPortal(
    <div
      style={{
        position: 'absolute',
        ...position,
        zIndex,
      }}
    >
      {children}
    </div>,
    document.body,
  );
}
